/*! Copyright (c) Safe As Milk. All rights reserved. */
import { debounce } from "utils";

class ScrollingMarquee extends HTMLElement {
    #debouncedSetMarqueeSpeed;
    constructor() {
        super();
        this.#debouncedSetMarqueeSpeed = debounce(this.#setMarqueeSpeed.bind(this), 50);
    }
    connectedCallback() {
        this.marqueeContainer = this.querySelector(".marquee");
        this.marqueeElements = Array.from(this.querySelectorAll(".marquee__content"));
        this.toggleBtn = this.querySelector(".scrolling-marquee__toggle-btn");

        if (this.toggleBtn) {
            this.toggleBtn.addEventListener("click", () => this.togglePlayPause());
        }

        this.resizeObserver = new ResizeObserver(this.#debouncedSetMarqueeSpeed);
        if (this.marqueeContainer) {
            this.resizeObserver.observe(this.marqueeContainer);
        }
        this.#setMarqueeSpeed();
    }
    disconnectedCallback() {
        if (this.marqueeContainer) {
            this.resizeObserver.unobserve(this.marqueeContainer);
        }
    }
    togglePlayPause() {
        const isPaused = this.classList.toggle("is-paused");
        if (this.toggleBtn) {
            const label = isPaused ? "Play scrolling text" : "Pause scrolling text";
            this.toggleBtn.setAttribute("aria-label", label);
            this.toggleBtn.setAttribute("aria-pressed", isPaused ? "true" : "false");
            
            const iconContainer = this.toggleBtn.querySelector(".scrolling-marquee__toggle-icon");
            if (iconContainer) {
                if (isPaused) {
                    iconContainer.innerHTML = '<svg class="icon icon--play" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><polygon points="4.5,2.5 13.5,8 4.5,13.5" /></svg>';
                } else {
                    iconContainer.innerHTML = '<svg class="icon icon--pause" width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><rect x="3" y="2" width="3.5" height="12" rx="1" /><rect x="9.5" y="2" width="3.5" height="12" rx="1" /></svg>';
                }
            }

            const textSpan = this.toggleBtn.querySelector(".scrolling-marquee__toggle-text");
            if (textSpan) {
                textSpan.textContent = label;
            }
        }
    }
    #setMarqueeSpeed() {
        if (!this.marqueeContainer) return;
        const marqueeComputedStyle = window.getComputedStyle(this.marqueeContainer);
        const gapValue = parseInt(marqueeComputedStyle.getPropertyValue("column-gap"), 10) || 0;
        const speed = (parseFloat(this.getAttribute("marquee-speed")) || 0) * 10;
        this.marqueeElements.forEach((element => {
            const elementWidth = element.offsetWidth + gapValue;
            const timeTaken = elementWidth / speed;
            element.style.animationDuration = `${timeTaken}s`;
        }));
    }
}

customElements.define("scrolling-marquee", ScrollingMarquee);
//# sourceMappingURL=scrolling-marquee.js.map
